import { Link } from "react-router-dom";

interface MarcaProps {
  completa?: boolean;
  inicio?: boolean;
  prioridade?: boolean;
  className?: string;
}

/**
 * A marca em duas formas.
 *
 * No cabeçalho, o nome fica em HTML: continua nítido em qualquer tela e o leitor
 * de tela recebe texto de verdade. O lockup completo é reservado ao rodapé, onde
 * há espaço para a composição vertical respirar.
 */
export function MarcaFotoInterativa({
  completa = false,
  inicio = true,
  prioridade = false,
  className = "",
}: MarcaProps) {
  const conteudo = completa ? (
    <img
      src="/landing/logo-foto-interativa-hero.webp"
      width={400}
      height={509}
      alt="Foto Interativa"
      loading={prioridade ? "eager" : "lazy"}
      fetchPriority={prioridade ? "high" : undefined}
      decoding="async"
      className={`h-auto ${className || "w-44"}`}
    />
  ) : (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/landing/logo-simbolo.png"
        width={512}
        height={416}
        alt=""
        className="h-10 w-12 object-contain sm:h-11 sm:w-14"
      />
      <span className="font-display text-[1.125rem] leading-none tracking-[-0.025em] text-lp-verde sm:text-[1.25rem]">
        Foto <em className="font-normal text-lp-ouro">Interativa</em>
      </span>
    </span>
  );

  return inicio ? (
    <Link to="/" aria-label="Foto Interativa, início" className="inline-flex shrink-0">
      {conteudo}
    </Link>
  ) : (
    conteudo
  );
}
